export class Chanels{
    public static readonly USER_CHANEL: string = "USER";
}